/**
 * Colorblind-safe color palettes
 * Based on ColorBrewer and Tol palettes that are accessible for colorblind users
 */

/**
 * Tol Bright palette - colorblind-safe qualitative palette
 * Good for categorical data with up to 8 categories
 */
export const TOL_BRIGHT_PALETTE = [
  '#4477AA', // Blue
  '#EE6677', // Red
  '#228833', // Green
  '#CCBB44', // Yellow
  '#66CCEE', // Cyan
  '#AA3377', // Magenta
  '#BBBBBB', // Light gray
  '#000000', // Black
];

/**
 * ColorBrewer Set2 - colorblind-safe qualitative palette
 * Softer colors, good for 8 categories
 */
export const COLORBREWER_SET2 = [
  '#66C2A5', // Teal
  '#FC8D62', // Orange
  '#8DA0CB', // Purple-blue
  '#E78AC3', // Pink
  '#A6D854', // Light green
  '#FFD92F', // Yellow
  '#E5C494', // Tan
  '#B3B3B3', // Gray
];

/**
 * ColorBrewer Set1 - colorblind-safe qualitative palette
 * More vibrant colors, good for 9 categories
 */
export const COLORBREWER_SET1 = [
  '#E41A1C', // Red
  '#377EB8', // Blue
  '#4DAF4A', // Green
  '#984EA3', // Purple
  '#FF7F00', // Orange
  '#FFFF33', // Yellow
  '#A65628', // Brown
  '#F781BF', // Pink
  '#999999', // Gray
];

/**
 * Default colorblind-safe palette (Tol Bright)
 */
export const DEFAULT_COLORBLIND_PALETTE = TOL_BRIGHT_PALETTE;

/**
 * Get a color from the palette by index (with wrapping)
 */
export function getColorblindColor(index: number, palette: string[] = DEFAULT_COLORBLIND_PALETTE): string {
  return palette[index % palette.length];
}










